<template>
  <div class="user-menu">
    <button class="close-btn" @click="$emit('close')" aria-label="Close">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
    <div class="user-name">
         <span>{{ JSON.parse(userInfo).username }}</span>
    </div>
    <ul>
      <li @click="goTo('/profile-information')">
        <span class="icon">👤</span>
        <span>{{ $t('profile.profileInformation') }}</span>
        <span class="arrow">›</span>
      </li>
      <li @click="goTo('/orderPage')">
        <span class="icon">📦</span>
        <span>{{ $t('profile.orderHistory') }}</span>
        <span class="arrow">›</span>
      </li>
      <!-- <li @click="goTo('/profile-buyNowSetting')">
        <span class="icon">🛒</span>
        <span>{{ $t('profile.buyNow') }}</span>
        <span class="arrow">›</span>
      </li> -->
      <li @click="goTo('/profile-address')">
        <span class="icon">🏠</span>
        <span>{{ $t('profile.shippingAddresses') }}</span>
        <span class="arrow">›</span>
      </li>
      <li @click="goTo('/coupons')">
        <span class="icon">🎁</span>
        <span>{{ $t('profile.coupons') }}</span>
        <span class="arrow">›</span>
      </li>
      <li @click="goTo('/favorite')">
        <span class="icon">❤️</span>
        <span>{{ $t('profile.favorite') }}</span>
        <span class="arrow">›</span>
      </li>
      <!-- <li @click="goTo('/paymentPage')">
        <span class="icon">💳</span>
        <span>{{ $t('profile.paymentMethods') }}</span>
        <span class="arrow">›</span>
      </li> -->
    </ul>
    <div class="logout-row">
     <button class="logout-btn" @click="handleLogout">
  <span>{{ $t('loginRegister.logout') }}</span>
</button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ElLoading, ElMessage } from 'element-plus'
import { removeToken } from '@/services/auth'


const { t } = useI18n()
const router = useRouter()
const emit = defineEmits(['close', 'logout'])
const userInfo = localStorage.getItem('userInfo')
function goTo(path) {
  router.push(path)
  emit('close')
}

async function handleLogout() {
  const loading = ElLoading.service({
    lock: true,
    background: 'rgba(255,255,255,0.7)'
  })
  try {
    await logout(localStorage.getItem('token') || '')
  } catch (e) {
    // 忽略接口异常
  }
  removeToken()
  localStorage.removeItem('token')
  localStorage.removeItem('userInfo')
  loading.close()
  ElMessage.success({
    message: t('loginRegister.logoutSuccess') || '退出登录成功',
    duration: 2000,
  })
  emit('logout')
  emit('close')         // 关闭弹窗
  router.push('/') 
}
</script>

<style scoped>
.user-menu {
  background: #fff;
  border-radius: 18px;
  min-width: 370px;
  max-width: 95vw;
  box-shadow: 0 8px 32px rgba(0,0,0,0.13);
  padding: 40px 36px 32px 36px;
  position: relative;
  font-family: 'Segoe UI', 'Arial', sans-serif;
  margin: 0 auto;
}
.user-name {
  position: absolute;
  top: 12px;
  left: 50px;
  font-size: 16px;
  font-weight: bold;
  color: #222;
  border-bottom: 1px solid #ccc;
}
.close-btn {
  position: absolute;
  top: 12px;
  right: 18px;
  background: none;
  border: none;
  font-size: 22px;
  color: #888;
  cursor: pointer;
  transition: color 0.2s;
  z-index: 2;
  line-height: 1;
  font-weight: 700;
  padding: 0 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.close-btn:hover {
  color: #c00;
}
.user-menu ul {
  list-style: none;
  padding: 0;
  margin: 0 0 32px 0;
}
.user-menu li {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 8px;
  font-size: 15px;
  color: #222;
  cursor: pointer;
  border-radius: 8px;
  padding: 5px 14px 13px 10px;
  transition: background 0.18s;
  position: relative;
}
.user-menu li:hover {
  background: #f5f7fa;
}
.icon {
  font-size: 22px;
  width: 28px;
  text-align: center;
}
.arrow {
  margin-left: auto;
  color: #bbb;
  font-size: 20px;
  font-weight: bold;
  transition: color 0.18s;
}
.user-menu li:hover .arrow {
  color: #fb6e01;
}
.logout-row {
  display: flex;
  justify-content: center;
  margin-top: 1px;
}

.logout-btn {
  width: 100% !important;
  background: #fff !important;
  color: #e53935 !important;
  border: 2px solid #e53935 !important;
  border-radius: 8px !important;
  padding: 10px 0 !important;
  font-weight: bold !important;
  font-size: 16px !important;
  cursor: pointer !important;
  letter-spacing: 1px !important;
  text-align: center !important;
  transition: background 0.18s, color 0.18s, border-color 0.18s !important;
  box-shadow: none !important;
  outline: none !important;
  margin: 0 auto !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 2px !important;
}
.logout-btn:hover {
  color: #fff !important;
  background: #e53935 !important;
  border-color: #e53935 !important;
}
.logout-icon {
  font-size: 22px !important;
}
</style>